import { gql } from "@apollo/client";

export const LIST_EVENTS = gql`
  query listEvents($filter: listEventsFilterInput) {
    listEvents(filter: $filter) {
      items {
        id
        eventName
        image
        eventLocation
        date
        country
        city
        state
        coordinates {
          latitude
          longitude
        }
        profile {
          name
          owner
          type
        }
        startDate
        endDate
        userId
        visibility
        description
        eventType
        sponsorshipTitle
        durationMinutes
        bufferMinutes
        capacity
        timezone
        dailyStartTime
        dailyEndTime
        breakStartTime
        breakEndTime
        dailySchedule {
          date
          startTime
          endTime
          breakStartTime
          breakEndTime
        }
        fullPaymentAtBooking
      }
    }
  }
`;
